module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-48.f0ca2a9e.png";